import React from "react";
import { Link } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";

type SidebarProps = {
  active: string;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;

  dashboardMenu: {
    name: string;
  }[];
};

const Sidebar: React.FC<SidebarProps> = ({
  active,
  setIsOpen,
  setActive,
  dashboardMenu,
}) => {
  return (
    <div className="hidden border-l border-midGreen lg:w-[15%] lg:flex flex-col left-0 top-0 shadow h-screen fixed bg-white ">
      <div className="flex flex-col  gap-[84px] pt-6">
        <Link to="/">
          <h1 className="w-[60%] mx-auto font-Poppins text-[16px] xl:text-[20px] font-bold leading-5 p-3 border rounded-md text-darkGreen bg-[#2157591A] text-center">
            ECOMOTO
          </h1>
        </Link>
        <div className="flex flex-col gap-6 items-start">
          {dashboardMenu.map((item, index) => (
            <p
              className={`flex items-center w-[80%] mx-auto gap-3 p-3 text-darkGreen text-[13px] xl:text-[16px] font-normal leading-5 border border-transparent rounded-xl cursor-pointer ${
                active === item.name
                  ? "bg-midGreen border-r-8 border-r-lightGreen  text-lightGreen "
                  : ""
              }`}
              onClick={() => {
                setActive(item.name);
                setIsOpen(false);
              }}
              key={index}
            >
              {item.name}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
